import React from "react";

// MUI
import SvgIcon from '@mui/material/SvgIcon';

// Types
import { SvgIconProps } from "@mui/material";

function MlinIcon(props: SvgIconProps) {
  return <SvgIcon {...props} >
    <svg version="1.1" id="MlinIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        // @ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <path fill="#FFFFFF" d="M79,56.3V43.8H67.3c-0.7-2.1-1.7-4.1-3.1-5.8l5.7-9.9l-10.8-6.3l-5.5,9.5c-1.3-0.3-2.7-0.4-4.1-0.4
	c-1.1,0-2.2,0.1-3.2,0.3l-5.4-9.4L30.1,28l5.3,9.2c-1.7,1.9-2.9,4.1-3.7,6.5H21v12.5h11.1c0.8,2.2,2.1,4.2,3.7,5.9L30.1,72l10.8,6.3
	l5.9-10.2c0.9,0.1,1.8,0.2,2.7,0.2c1.2,0,2.4-0.1,3.6-0.3l6,10.3L69.9,72l-6-10.4c1.3-1.6,2.4-3.4,3.1-5.3H79L79,56.3z"/>
      <path fill="#3CAA78" d="M64.2,52.5h11v-4.9H64.3c-0.4-3.2-1.9-6.2-4.2-8.5c-0.2-0.2-0.4-0.4-0.6-0.6l5.2-9.1L60.5,27l-5.1,8.9
	c-1.8-0.8-3.8-1.2-5.8-1.2c-1.8,0-3.5,0.3-5.1,0.9l-5-8.6l-4.2,2.4l4.9,8.5c-0.4,0.3-0.8,0.7-1.2,1.1c-2.3,2.3-3.8,5.3-4.2,8.5h-10
	v4.9h10.1c0.6,2.9,2,5.5,4.1,7.6c0.5,0.5,1,1,1.6,1.4l-5.3,9.1l4.2,2.4l5.4-9.3c1.5,0.5,3,0.7,4.6,0.7c1.9,0,3.7-0.3,5.4-1l5.5,9.6
	l4.2-2.4L59,60.8c0.3-0.3,0.6-0.6,0.9-0.9C62.2,58,63.6,55.3,64.2,52.5z M49.5,59.6c-5.5,0-10-4.5-10-10s4.5-10,10-10s10,4.5,10,10
	C59.6,55.1,55.1,59.6,49.5,59.6z"/>
    </svg>
  </SvgIcon>
}

export default MlinIcon;
